import React, { useContext, useEffect, useState } from "react"
import BoxComponent from "../../../../../../components/Box/BoxComponent";
import ButtonComponent from "../../../../../../components/Button/ButtonComponent";
import FormComponent from "../../../../../../components/form/FormComponent";
import NovoEnderecoFields from "../../../../../Pedidos/components/drawer/NovoEnderecoFields";
import { UsuarioEnderecos } from "../../../../../../provider/auth/AuthProps";
import TextFieldComponent from "../../../../../../components/TextField/TextFieldComponent";
import { CampoPedidoInputStyle, CampoPedidoLabelStyle, CampoPedidoStyle } from "../../../../../Pedidos/components/modal/novo_pedido/InfoPedidoComponent";
import { Autocomplete, TextField } from "@mui/material";
import { MunicipioDTO, UfDTO } from "../../../../../../interface/Localidade";
import { localidadeService } from "../../../../../../service/LocalidadeService";
import SelectComponent from "../../../../../../components/Select/SelectComponent";
import { enderecoService } from "../../../../../../service/EnderecoService";
import LabelComponent from "../../../../../../components/Label/LabelComponent";
import TypographyComponent from "../../../../../../components/Typography/ThypographyComponent";
import { AuthContext } from "../../../../../../provider/auth/AuthContext";
import { usuarioService } from "../../../../../../service/UsuarioService";

interface EtapaEnderecoEntregaProps {
    enderecoSelecionado: (endereco: UsuarioEnderecos) => void;
}

const EtapaEnderecoEntregaComponent = (props: EtapaEnderecoEntregaProps) => {
    const {cliente} = useContext(AuthContext);

    const [renderNovoEndereco, setRenderNovoEndereco] = useState<boolean>(false);
    const [endereco, setEndereco] = useState<UsuarioEnderecos>();

    const [municipios, setMunicipios] = useState<MunicipioDTO[]>([]);
    const [municipio, setMunicipio] = useState<MunicipioDTO>();
    const [ufs, setUfs] = useState<UfDTO[]>([]);

    const [enderecos, setEnderecos] = useState<UsuarioEnderecos[]>([]);
    const [enderecoSelecionado, setEnderecoSelecionado] = useState<number | null>(null);

    useEffect(() => {
        getUfs();

        if (cliente) {
            const enderecosUsuario = usuarioService.getEnderecosPorTelefoneLocalStorage(cliente.telefoneCompleto);
            if (enderecosUsuario !== null) setEnderecos(enderecosUsuario);
        }
    }, [])

    const getUfs = async () => {
        try {
            const response = await localidadeService.getUfs();
            setUfs(response.data);
        } catch (err: any) {
            alert("Erro ao buscar as unidades da federação.");
        }
    }

    const getMunicipios = async (name: string) => {
        try {
            const response = await localidadeService.getMunicipios(name);
            setMunicipios(response.data);
        } catch (err: any) {
            alert("Erro ao buscar os municípios.");
        }
    }

    const handleClickNovoEndereco = () => {
        setRenderNovoEndereco(true);
    }

    const handleSaveEndereco = (event: any) => {
        event.preventDefault();

        if (endereco) {

            const novoEndereco = {
                ...endereco,
                enderecoCompleto: enderecoService.createEnderecoCompleto(endereco)
            };

            setEnderecos(prev => [...prev, novoEndereco]);

            setEnderecoSelecionado(enderecos.length);

            setEndereco({
                //id: 0,
                nome: "",
                enderecoCompleto: "",
                endereco: "",
                rua: "",
                quadra: "",
                numero: "",
                bairro: "",
                cep: "",
                cidade: "",
                estado: "",
                pontoReferencia: ""
            });
            setRenderNovoEndereco(false);

            props.enderecoSelecionado(novoEndereco);

            if (cliente !== null && cliente.telefoneCompleto) {
                usuarioService.salvaEnderecoPorTelefone(cliente.telefoneCompleto, novoEndereco);
            }
        }
    }

    const handleChangeEndereco = (campo: string, valor: string) => {
        setEndereco({
            ...endereco,
            [campo]: valor
        } as UsuarioEnderecos);
    }

    const handleCancelaEndereco = () => {
        setEndereco({
            id: 0,
            nome: "",
            enderecoCompleto: "",
            endereco: "",
            rua: "",
            quadra: "",
            numero: "",
            bairro: "",
            cep: "",
            cidade: "",
            estado: "",
            pontoReferencia: ""
        });

        setRenderNovoEndereco(false);
    }

    const renderCamposNovoEndereco = () => {
        return <BoxComponent component="form" sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2
        }}
            onSubmit={(e: any) => handleSaveEndereco(e)}
        >
            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: "0 0 100%" }}>
                <TextFieldComponent
                    id="nome_endereco"
                    label="Nome"
                    value={endereco?.nome || ""}
                    onChange={e => handleChangeEndereco("nome", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                    required
                />
            </BoxComponent>
            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: "0 0 100%" }}>
                <TextFieldComponent
                    id="rua_cliente"
                    label="Rua"
                    value={endereco?.rua || ""}
                    onChange={e => handleChangeEndereco("rua", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                    required
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: 1 }}>
                <TextFieldComponent
                    id="quadra_cliente"
                    label="Quadra"
                    placeholder=""
                    value={endereco?.quadra}
                    onChange={e => handleChangeEndereco("quadra", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                    required
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: 1 }}>
                <TextFieldComponent
                    id="numero_cliente"
                    label="Número"
                    placeholder=""
                    value={endereco?.numero}
                    onChange={e => handleChangeEndereco("numero", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: "0 0 100%" }}>
                <TextFieldComponent
                    id="complemento_cliente"
                    label="Complemento"
                    placeholder=""
                    value={endereco?.complemento}
                    onChange={e => handleChangeEndereco("complemento", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: 1 }}>
                <TextFieldComponent
                    id="bairro_cliente"
                    label="Bairro"
                    placeholder=""
                    value={endereco?.bairro}
                    onChange={e => handleChangeEndereco("bairro", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    required
                    variant="outlined"
                    size="small"
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: 1 }}>
                <TextFieldComponent
                    id="cep_cliente"
                    label="CEP"
                    placeholder=""
                    value={endereco?.cep}
                    onChange={e => handleChangeEndereco("cep", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                />
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, width: "100%" }}>
                <BoxComponent component="div" sx={{}}>
                    <Autocomplete
                        disablePortal
                        options={municipios}

                        getOptionLabel={(option) => {
                            return `${option.municipio}`
                        }}

                        value={municipio || null}

                        inputValue={endereco?.cidade || ""}

                        onInputChange={(_, newInputValue) => {
                            handleChangeEndereco("cidade", newInputValue)
                            /*
                            setEndereco({
                                //...props.userData,
                                ...endereco,
                                cidade: newInputValue
                            } as UsuarioEnderecos);
                             */

                            if (newInputValue.length > 3) {
                                getMunicipios(newInputValue);
                            }
                        }}

                        onChange={(_, newValue: any) => {
                            setMunicipio(newValue || undefined);

                            handleChangeEndereco("cidade", newValue?.municipio);
                            handleChangeEndereco("estado", newValue?.uf);
                            /*
                            setEndereco({
                                ...endereco,
                                cidade: newValue?.municipio || "",
                                estado: newValue?.uf || ""
                            } as UsuarioEnderecos);
                             */
                        }}

                        isOptionEqualToValue={(option, value) =>
                            option.municipio === value.municipio
                        }

                        filterOptions={(x) => x}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Cidade"
                                placeholder="Digite a cidade..."
                                variant="outlined"
                                // sx={CampoPedidoInputStyle}
                                required
                                size="small"
                            />
                        )}

                        ListboxProps={{
                            style: {
                                maxHeight: 200,
                                zIndex: 9999
                            }
                        }}

                        sx={{
                            width: "100%"
                        }}
                    />
                </BoxComponent>
            </BoxComponent>
            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, width: "100%" }}>
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                    <SelectComponent
                        id="uf_cliente"
                        label="UF"
                        options={
                            ufs.map((element: UfDTO) => {
                                return {
                                    label: element.nome,
                                    value: element.sigla
                                }
                            })
                        }
                        onChange={(e: any) => {
                            /*
                            handleChangeEnderecoUserData({
                                ...props.userData,
                                estado: e
                            } as Usuario);
                             */
                            handleChangeEndereco("estado", e);
                        }}
                        value={endereco?.estado || ''}
                        MenuProps={{
                            disablePortal: true,
                            PaperProps: {
                                sx: {
                                    zIndex: 2000
                                }
                            }
                        }}
                        // sx={{ ...CampoPedidoInputStyle }}
                        required
                        size="small"
                    />
                </BoxComponent>
            </BoxComponent>

            <BoxComponent component="div" sx={{ ...CampoPedidoStyle, background: "transparent", px: 0, flex: 1 }}>
                <TextFieldComponent
                    id="ponto_referencia"
                    label="Ponto de referência"
                    placeholder="Casa de muro marrom, próximo do mercado..."
                    value={endereco?.cep}
                    onChange={e => handleChangeEndereco("pontoReferencia", e.target.value)}
                    fullWidth
                    //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                    variant="outlined"
                    size="small"
                    multiline
                />
            </BoxComponent>

            <BoxComponent component="footer" sx={{
                display: "flex", justifyContent: "space-between", width: "100%", gap: 1.5
            }}>
                <ButtonComponent id="botao-salvar-endereco"
                    type="submit"
                    sx={{
                        width: "100%",
                        height: '40px',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        borderRadius: '10.4px',
                        backgroundColor: '#E7000B',
                        opacity: 1,
                        boxSizing: 'border-box',
                        textTransform: 'none', // Evita que o MUI force caixa alta

                        // Fusão da Tipografia
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 700,
                        fontSize: '16px',
                        lineHeight: '24px', // Mapeado do s+
                        letterSpacing: '0%',
                        color: '#FFFFFF', // Cor branca para contraste no fundo vermelho
                        textAlign: 'center',

                        '&:hover': {
                            backgroundColor: '#C40009', // Feedback visual para o hover
                        }
                    }}
                >
                    Salvar
                </ButtonComponent>

                <ButtonComponent id="botao-cancelar-endereco"
                    sx={{
                        width: "100%",
                        height: '40px',
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        borderRadius: '10.4px',
                        backgroundColor: '#D1D5DC',
                        opacity: 1,
                        boxSizing: 'border-box',
                        textTransform: 'none', // Evita que o MUI force caixa alta

                        // Fusão da Tipografia
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 700,
                        fontSize: '16px',
                        lineHeight: '24px', // Mapeado do s+
                        letterSpacing: '0%',
                        textAlign: 'center',
                        color: "#101828",

                        '&:hover': {
                            backgroundColor: '#D1D5DF', // Feedback visual para o hover
                        }
                    }}
                    onClick={() => {
                        handleCancelaEndereco();
                    }}
                >
                    Cancelar
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>

        // return <NovoEnderecoFields
        //     endereco={endereco}
        //     onSubmit={(e: any) => handleSaveEndereco(e)}
        //     onChange={(campo: string, valor: any) => handleChangeEndereco(campo, valor)}
        //     cancelaEndereco={handleCancelaEndereco}
        // />
    }

    const renderEnderecos = () => {
        return <BoxComponent component="div"
            sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: "auto", height: "50%" }}
        >
            {enderecos && enderecos.map((element: UsuarioEnderecos, index: number) => {
                return <LabelComponent key={`endereco_${index}`} htmlFor={`endereco_${index}`}
                    sx={{
                        ...CampoPedidoLabelStyle,
                        //height: '98.39px',
                        height: "auto",
                        display: 'flex',
                        gap: 2,
                        opacity: 1,
                        borderRadius: '10.4px',
                        padding: '16.2px',
                        border: '1px solid #E5E7EB',
                        boxSizing: 'border-box',
                        alignItems: '',
                        verticalAlign: null,
                    }}
                >
                    <TextFieldComponent
                        id={`endereco_${index}`}
                        type="radio"
                        checked={enderecoSelecionado === index}
                        onChange={() => {                            
                            setEnderecoSelecionado(index);
                            props.enderecoSelecionado(enderecos[index]);
                        }}
                        sx={{
                            width: "10%",
                            border: "none"
                        }}
                    //value={props.userData?.telefoneCompleto}
                    //onChange={handleChange("telefoneCompleto")}
                    //fullWidth
                    //sx={{ ...CampoPedidoInputStyle }}
                    />

                    <BoxComponent component="div">
                        <TypographyComponent
                            variant="body2" fontWeight="bold"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                color: '#101828',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.nome}
                        </TypographyComponent>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#4A5565',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.enderecoCompleto}
                        </TypographyComponent>
                    </BoxComponent>
                </LabelComponent>
            })}

            {/* {props.userData?.enderecos && props.userData.enderecos.length == 0 && <p>Não tem endereços</p>} */}
        </BoxComponent>
    }

    return <BoxComponent
        component="div"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            flexGrow: 1,
            minHeight: 0,
            p: 2,
            boxSizing: 'border-box',
            overflow: "auto",
            height: "50%",
            gap: 2
        }}
    >
        {renderNovoEndereco ? (
            <>
                {renderCamposNovoEndereco()}
            </>
        ) : (
            <>
                {renderEnderecos()}

                <ButtonComponent id="add_endereco"
                    type="button"
                    sx={{
                        //width: '624px',
                        width: "100%",
                        height: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '16.2px',
                        borderRadius: '10.4px',
                        border: '1px dashed #D1D5DC',
                        opacity: 1,
                        boxSizing: 'border-box',
                        backgroundColor: 'transparent',
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '12px',
                        lineHeight: '24px',
                        letterSpacing: '0%',
                        color: '#4A5565',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        textTransform: "none"
                    }}
                    onClick={handleClickNovoEndereco}
                >
                    + Adicionar novo endereço
                </ButtonComponent>
            </>
        )}


    </BoxComponent >
}

export default EtapaEnderecoEntregaComponent;